import {Component, OnInit, ViewChild, TemplateRef} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import * as _ from 'lodash';
import {ProfileListComponent} from '../profile-list/profile-list.component';
import {MODAL_CONFIG} from '../../../services/constant';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'profile-list-detail',
  templateUrl: './profile-list-detail.component.html',
  styleUrls: ['./profile-list-detail.component.scss']
})
export class ProfileListDetailComponent implements OnInit {
  modalRef: BsModalRef;
  user: any = {};
  groups: any = [];
  companyGroups: any[] = [];
  title = '';
  createMode = false;
  errorMessage: string = null;
  errorMsgForShow: string = null;
  errorMsgForShows: string = null;
  passwordPlaceHolder = '';
  parent: ProfileListComponent = null;
  checkUser = false;
  department: any = {};
  allSellerBranches: any[] = [];
  sellerBranchChoices: any[] = [];

  @ViewChild('modalTemplate') modalTemplate: TemplateRef<any>;

  constructor(
    private apiService: ApiService,
    private modalService: BsModalService,
    private translate: TranslateService
  ) {}

  open(parent: ProfileListComponent, selectedUser) {
    this.parent = parent;
    this.errorMessage = null;

    if (selectedUser) {
      this.user = _.cloneDeep(selectedUser);
      this.user.group = this.user.group.id;
      delete this.user.status;
      this.createMode = false;
      this.checkUser = true;
      this.title = this.translate.instant('PROFILE.LIST.MODAL.TITLE') + ' : ' + this.user.username;
      this.passwordPlaceHolder = '(' + this.translate.instant('PROFILE.LIST.MODAL.PASSWORD-PLACEHOLDER') + ')';
      this.filterBranches();
    } else {
      this.user = {
        group: this.groups[0]['value'],
        company_group_id: [],
        branches: [],
        department_id: []
      };
      this.createMode = true;
      this.checkUser = false;
      this.title = this.translate.instant('PROFILE.LIST.MODAL.ADD-USER');
      this.passwordPlaceHolder = this.translate.instant('PROFILE.LIST.MODAL.PASSWORD');
    }

    this.modalRef = this.modalService.show(this.modalTemplate, MODAL_CONFIG);
  }

  ngOnInit() {
    this.loadGroups();
    this.loadCompanyGroups();
    this.loadDepartment();
    this.loadSellerBranches();
  }

  loadSellerBranches() {
    this.sellerBranchChoices = [];
    this.apiService.getDropdownBranch().subscribe(
      (sellerBranches: any[]) => {
        this.allSellerBranches = sellerBranches;
      });
  }

  filterBranches() {
    const selectedCompanyGroup = new Set(this.user.company_group_id);
    this.sellerBranchChoices = this.allSellerBranches
      .filter((item) => selectedCompanyGroup.has(item.company_group_id))
      .map((item) => ({label: item.full_name, value: item.id}));
    this.removeInvalidBranches();
  }

  removeInvalidBranches() {
    this.user.branches = this.user.branches.filter((branch) => this.sellerBranchChoices.find((item) => item.value === branch));
  }

  submit() {
    if (this.translate.currentLang === 'th') {
      const errorField = [];
      this.errorMessage = null;

      !this.user.username && errorField.push('ชื่อผู้ใช้งาน');
      !this.user.company_group_id.length && errorField.push('บริษัท');
      !this.user.branches.length && errorField.push('สาขา');
      this.createMode && !this.user.password && errorField.push('รหัสผ่าน');

      if (errorField.length > 0) {
        this.errorMessage = 'โปรดกรอก ' + errorField.join(', ') + ' ให้ถูกต้อง';
        return;
      }
    } else {
      const errorField = [];
      this.errorMessage = null;

      !this.user.username && errorField.push('Username');
      !this.user.company_group_id.length && errorField.push('Company');
      !this.user.branches.length && errorField.push('Branch');
      this.createMode && !this.user.password && errorField.push('Password');

      if (errorField.length > 0) {
        this.errorMessage = 'Please fill ' + errorField.join(', ') + ' correctly';
        return;
      }
    }

    let request = null;

    if (this.createMode) {
      request = this.apiService.createUser(this.user);
      const role_name = this.groups.find(x => x.value === this.user.group).label;
      this.sniff('CREATE_USER', role_name + ': ' + this.user.username);
    } else {
      request = this.apiService.updateUser(this.user);
      this.sniff('UPDATE_USER',  this.title + ' to ' + this.user.username);
    }

    request.subscribe(
      (obj) => {
        this.parent.reload();
        this.modalRef.hide();
        this.clearData();
      },
      error => {
        this.checkErrorMsg(error);
      }
    );
  }

  checkErrorMsg(error) {
    this.errorMessage = this.apiService.getErrorMessage(error);
  }

  clearData() {
    this.user = {};
    this.errorMsgForShow = null;
  }

  close() {
    this.modalRef.hide();
    this.clearData();
  }

  disableUser() {
    this.sniff('DISABLE_USER', this.user.username);
    const request = this.apiService.deleteUser(this.user);
    request.subscribe(
      (obj) => {
        this.parent.reload();
        this.modalRef.hide();
      },
      error => {
        this.checkErrorAllMsg(error);
      }
    );
  }

  checkErrorAllMsg(error) {
    this.errorMsgForShows = this.apiService.getErrorMessage(error);
    if (this.translate.currentLang === 'en') {
      this.errorMessage = this.errorMsgForShows[0];
    } else {
      this.errorMessage = this.errorMsgForShows[1];
    }
  }

  enableUser() {
    this.sniff('ENABLE_USER', this.user.username);
    this.user.is_active = true;
    const request = this.apiService.updateUser(this.user);

    request.subscribe(
      (obj) => {
        this.parent.reload();
        this.modalRef.hide();
      },
      error => {
        this.errorMessage = this.apiService.getErrorMessage(error);
      }
    );
  }

  loadGroups() {
    this.groups = [];
    const params = {
      source: 'profile'
    };
    this.apiService.getRoles(params).subscribe(
      (groups) => {
        _.forEach(groups, (group) => {
          this.groups.push({
            'label': group['name'],
            'value': group['id']
          });
        });
      },
      error => {
        console.log('error', error);
      }
    );
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'MANAGE_USERS',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }

  loadCompanyGroups() {
    this.companyGroups = [];

    this.apiService.getCompanyGroups().subscribe(
      (res: any[]) => {
        _.forEach(res, (cg) => {
          this.companyGroups.push({
            'label': cg['company_group'],
            'value': cg['id']
          });
        });
      },
      error => {
        console.log('error', error);
      }
    );
  }

  loadDepartment(): void {
    this.apiService.getDepartments().subscribe(
      (res: any) => {
        if (res.length > 0) {
          if (this.translate.currentLang === 'en') {
            this.department = res.map(
              (department) => ({
                label: department.name_en,
                value: department.id,
              })
            );
          } else {
            this.department = res.map(
              (department) => ({
                label: department.name_th,
                value: department.id,
              })
            );
          }
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-list-detail/profile-list-detail.component.ts